export const i18nRoot = "media_player.settings";
export const formId = "media-settings-form";
